import { AvatarDropdown as CoreAvatarDropdown } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  return <CoreAvatarDropdown appId={BizAppConfig.appSsoClientId} />;
};

export default AvatarDropdown;
